<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid :menuActive="'/user/collect'"></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg
                  t="1653550300495"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1751"
                  width="64"
                  height="64"
                >
                  <path
                    d="M517.89889355 672.14217411c-69.12795966 0-129.87677391-31.42179956-163.39335982-56.55924012-18.85308003-14.66350735-20.94786639-41.89573277-6.2843605-58.65402644 14.66350735-18.85308003 41.89573277-20.94786639 58.65402644-6.28436051 4.18957267 4.18957267 108.92890754 83.791467 207.38388042 0 16.7582937-14.66350735 43.99052059-12.56871953 58.65402645 4.18957268 14.66350735 16.7582937 12.56871953 43.99052059-4.18957268 58.65402794-48.18009327 43.99052059-102.64454703 58.65402644-150.82464031 58.65402645z"
                    p-id="1752"
                  ></path>
                  <path
                    d="M777.65243992 984.2653879c-8.37914686 0-18.85308003-2.09478635-27.23222541-6.28436051L511.61453306 881.62084087l-238.80567999 96.36018652c-23.04265273 10.47393318-50.27487962 6.2843605-69.12795965-8.37914684-20.94786639-14.66350735-31.42179956-37.70616007-29.3270147-62.84359914l18.85308006-257.6587615-165.48814621-196.90994723c-16.7582937-18.85308003-20.94786639-46.08530691-12.56871952-69.12795964 8.37914686-23.04265273 27.23222688-41.89573277 52.36966595-48.18009324l249.27961465-62.84360063 136.16113295-217.8578136c12.56871953-20.94786639 35.61137374-33.51658738 60.7488128-33.51658591s48.18009327 12.56871953 60.74881427 33.51658591l136.16113294 217.8578136 249.27961464 62.84360063c25.13744054 6.2843605 43.99052059 23.04265273 52.36966596 48.18009324 8.37914686 23.04265273 2.09478635 50.27487962-12.56871953 69.12795964l-165.48814766 196.90994723 18.85308006 257.6587615c2.09478635 25.13744054-8.37914686 48.18009327-29.32701325 62.84359914-14.66350735 10.47393318-29.32701323 14.66350735-46.08530691 14.66350735z m-266.03790686-188.53080037c6.2843605 0 10.47393318 0 16.75829368 2.09478633l236.71089365 96.36018653-18.85308005-255.56397367c0-10.47393318 2.09478635-20.94786639 10.4739332-29.32701323l165.48814765-196.90994722-249.27961465-62.84359913c-10.47393318-2.09478635-18.85308003-8.37914686-25.13743907-18.85308006L511.61453306 114.92891985l-136.16113295 217.8578136c-6.2843605 8.37914686-14.66350735 16.7582937-25.13744053 18.85308002l-249.27961319 62.84359916 165.48814618 196.90994721c6.2843605 8.37914686 10.47393318 18.85308003 10.47393319 29.32701323l-18.85308005 255.56397514 236.71089363-96.36018799c6.2843605-4.18957267 12.56871953-4.18957267 16.75829372-4.18957269z"
                    p-id="1753"
                  ></path>
                </svg>
                我的收藏
              </h2>
            </div>
            <div class="box">
              <div class="list-top">
                <div class="list-page-total">
                  共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                </div>
                <div class="list-search">
                  <el-input placeholder="" size="small" v-model="searchTitle">
                    <el-button
                      slot="append"
                      size="small"
                      type="primary"
                      @click="handleSearch"
                    >
                      查询
                    </el-button>
                  </el-input>
                </div>
              </div>

              <div class="box-content" v-loading="loading">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column
                    align="center"
                    label="序号"
                    type="index"
                    width="80"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="标题"
                    min-width=""
                    prop="eventTitle"
                  >
                  </el-table-column>
                  <el-table-column align="center" label="时间" width="250">
                    <template #default="scope">
                      {{ dateFormat(scope.row.createTime) }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="250">
                    <template #default="scope">
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-view"
                        @click="handleView(scope.row.dataId)"
                        >查看
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="list-bottom">
                  <div class="list-page-total">
                    共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                  </div>
                  <div class="list-page">
                    <el-pagination
                      :current-page="pageIndex"
                      :page-size="pageSize"
                      layout="prev,pager,next,jumper"
                      :total="total"
                      @current-change="handleCurrentPageChange"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  components: { UserLeftGuid },
  data() {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0,
      loading: false,
      searchTitle: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    dateFormat(cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    getList() {
      this.loading = true;

      axiosRequest(
        "/user/collect-list",
        {
          title: this.searchTitle,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
            this.tableData = res.data.data.records;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCurrentPageChange(currentPage) {
      this.pageIndex = currentPage;
      this.getList();
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    handleView(id) {
      if (id) {
        this.$router.push({ name: "case_details", params: { id: id } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/usercenter.scss";
</style>
